import { useState } from 'react';
import SpendChart from './SpendChart';
import { CHART_HEIGHT } from '../../shared/AppConstants';
import {
  Alert,
  AlertTitle,
  Box,
  Card,
  Tooltip,
  Typography
} from '@mui/material';
import { getContactUsLink } from '../../shared/UtilFunctions';
import { Link } from 'react-router-dom';

export default function SpendChartWrapper({
  data,
  chart_colors,
  chart_datasets,
  rename_map,
  title,
  titleTooltip,
  subTitle,
  noSpendMsg,
  noSpendErrMsg,
  userId,
  singleLineLegend
}) {
  const [activeBarIndex] = useState(-1);
  const [disabledIndices, setDisabledIndices] = useState(new Set());

  const handleToggleDataSetIndex = (datasetIndex) => {
    const _set = new Set([...disabledIndices]);

    if (disabledIndices.has(datasetIndex)) {
      _set.delete(datasetIndex);
    } else {
      _set.add(datasetIndex);
    }

    setDisabledIndices(_set);
  };

  function openLink(e, url) {
    e.preventDefault();

    window.open(url);
  }

  return (
    <Card sx={{ p: '1rem' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        <Typography variant={'h2'}>{title}</Typography>
        {titleTooltip && (
          <Tooltip title={titleTooltip} placement={'top-start'}>
            <fuel-icon name={'info_outlined'} />
          </Tooltip>
        )}
      </Box>
      <Typography variant="bodyMedium" gutterBottom>
        {subTitle}
      </Typography>
      {data && data.length > 0 ? (
        <>
          {noSpendErrMsg != null && (
            <Box
              marginX="auto"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Alert severity="warning">
                <AlertTitle>{noSpendErrMsg}</AlertTitle>
                <Link onClick={(e) => openLink(e, getContactUsLink(userId))}>
                  Contact Us
                </Link>
              </Alert>
            </Box>
          )}
          <SpendChart
            activeBarIndex={activeBarIndex}
            height={CHART_HEIGHT}
            onToggleDataset={handleToggleDataSetIndex}
            spendData={data}
            disabledDatasetIndices={disabledIndices}
            chart_datasets={chart_datasets}
            chart_colors={chart_colors}
            rename_map={rename_map}
            singleLineLegend={singleLineLegend}
          />
        </>
      ) : (
        <Box marginX="auto" p={4}>
          <Alert>{noSpendMsg}</Alert>
        </Box>
      )}
    </Card>
  );
}
